import axios from 'axios';
import { authenticate, isAuthenticated } from '../services/auth';

// Create axios instance
const instance = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 30000, // 30 seconds timeout for production server
  maxRedirects: 5,
  // HTTP/2 and keep-alive optimizations
  httpAgent: typeof window === 'undefined' ? null : undefined,
  httpsAgent: typeof window === 'undefined' ? null : undefined,
  headers: {
    'Connection': 'keep-alive',
  },
});

// Request interceptor to add token
instance.interceptors.request.use(
  (config) => {
    const { token } = isAuthenticated() || {};
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token refresh as backup
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const { refreshToken } = isAuthenticated() || {};
      if (refreshToken) {
        try {
          const res = await axios.post(`${process.env.REACT_APP_API}/auth/refresh-token`, {
            refreshToken,
          });
          const { token, refreshToken: newRefreshToken } = res.data;
          // Update localStorage
          const userData = isAuthenticated();
          userData.token = token;
          userData.refreshToken = newRefreshToken;
          authenticate(userData);
          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return instance(originalRequest);
        } catch (refreshError) {
          // Refresh failed, logout
          if (typeof window !== 'undefined') {
            localStorage.removeItem('buynsell');
            window.location.href = '/login';
          }
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;